import Rollbar from 'rollbar';
import { createApp } from 'vue'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "@vueform/slider/themes/default.css";

window.Vue = require('vue');
window.wNumb = require('wnumb');
window.VueCurrencyFilter = require('./currency');
window.collect = require('collect.js')

import App from './app.vue';
import router from './router';

import moment from 'moment'
import axios from 'axios'
import Notifications from '@kyvg/vue3-notification'
import FloatingVue from 'floating-vue'

import 'floating-vue/dist/style.css'

import store from './store';
import helpers from "./helpers/plugin.js";

const app = createApp({
    el: '#app',
    template: '<App/>',
    components: {
        App
    },
});

if (process.env.MIX_APP_ENV !== "dev") {
    const rollbar = new Rollbar({
        accessToken: "5bb4e68096874f0391b53fc8cce09f11",
        captureUncaught: true,
        captureUnhandledRejections: true,
    });

    // Vue 3 replacement for Vue.prototype.$rollbar
    app.config.globalProperties.$rollbar = rollbar;

    // Vue 3 replacement for Vue.config.errorHandler
    app.config.errorHandler = (err, instance, info) => {
        // instance can be null in some cases, so guard it
        rollbar.error(err, { info });

        // Optional: rethrow if you explicitly want to crash in runtime
        // throw err;
    };
}

app.use(Notifications);
app.use(FloatingVue);
app.use(helpers);
app.use(router);
app.use(store);

app.provide('origoStatus', (jaamaStatus, adminPortalPrimaryProduct) => {
    switch(jaamaStatus)
    {
        case 'TBC':
            return adminPortalPrimaryProduct.order_statuses_funding_documents_heading;
        case 'Supplier Added':
        case 'Suppliers Added':
        case 'Preferred Supplier Selected':
            return adminPortalPrimaryProduct.order_statuses_quote_submitted_heading;
        case 'Order Placed':
        case 'Order Accepted':
        case 'Stock':
            return adminPortalPrimaryProduct.order_statuses_order_confirmed_heading;
        case 'Delivery Offered':
            return adminPortalPrimaryProduct.order_statuses_arrived_in_stock_heading;
        case 'Delivery Arranged':
        case 'Contract Implemented':
            return adminPortalPrimaryProduct.order_statuses_delivery_organised_heading;
        case 'Implemented':
            return adminPortalPrimaryProduct.order_statuses_vehicle_delivered_heading;
        default:
            return jaamaStatus;
    }
});

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default));

app.config.globalProperties.$log = console.log;
app.config.globalProperties.$http = axios;
app.config.globalProperties.kebab = (str) => {
    if (str) {
        return str
            .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
            .map(x => x.toLowerCase())
            .join('-');
    }
};

app.mount('#app');
